export default __webpack_public_path__ + "static/media/jane-churchyard-benefits-4.fa720ea9.jpg";